import { clearQueue, fetchMyProgress, flushQueue } from './finds-client'
import { useFindsStore } from './finds.store'

/**
 * Brings this device in line with the server. The reset is applied before the queue is flushed,
 * so a find that was waiting to be sent from before an admin reset is dropped, not re-created.
 */
export async function syncFromServer(): Promise<void> {
  const { finds, resetAt } = await fetchMyProgress()
  const store = useFindsStore.getState()
  if (store.applyReset(resetAt)) clearQueue()
  await flushQueue()
  store.mergeServer(finds)
}
